import { useState, useEffect } from 'react';
import { FaRegClock } from 'react-icons/fa';
import moment from 'moment';

const Countdown = ({ gameTime, setIsLive, setComplete }) => {
	const [countdown, setCountdown] = useState(undefined);

	useEffect(() => {
		const interval = setInterval(() => {
			const game = gameTime;
			const now = moment();
			const distance = game.diff(now);

			if (distance <= 0 && distance > -7200000) {
				setIsLive(true);
				return null;
			} else if (distance <= 0) {
				clearInterval(interval);
				setIsLive(false);
			}

			const duration = moment.duration(distance);

			if (duration.days() !== 0) {
				setCountdown(duration.days() + 'd');
			} else if (duration.hours() !== 0) {
				setCountdown(duration.hours() + 'h ' + duration.minutes() + 'm');
			} else {
				setCountdown(duration.minutes() + 'm ' + duration.seconds() + 's');
			}
		}, 1000);

		return () => clearInterval(interval);
	}, [gameTime, setIsLive]);

	return (
		<p className='countdown'>
			<FaRegClock size={10} />
			{countdown}
		</p>
	);
};

export default Countdown;
